/**
 * Os textos montados da conferência da leitura (E140.F3): onde está cada pendência, como o perito
 * a procura no papel.
 */
import { ptBR } from '@/i18n/pt-BR';
import type {
  AchadoDoDocumentoData,
  PendenciaDaLeituraData,
  TipoDoAchado,
} from '@/lib/conferencia_da_leitura';

import { preencher } from '../FichaDaLeitura/textos';

export { preencher };

export const t = ptBR.conferenciaDaLeitura;
/** "Rever leitura de um campo" (E155.F3): o mesmo texto da ficha, onde o cartão abre. */
export const reverLeitura = ptBR.fichaDaLeitura.releitura.abrir;

/** O nome de cada achado na tela (a chave do servidor não vai para os textos). */
export const ROTULO_DO_ACHADO: Record<TipoDoAchado, string> = {
  marcador_de_modelo: t.achado.marcadorNaoPreenchido,
  campo_em_branco: t.achado.campoEmBranco,
};
const nomesDosCampos = ptBR.fichaDaLeitura.campo;

/** "dossie.pdf · página 3", o campo essencial, ou o arquivo. */
export function ondeEsta(p: PendenciaDaLeituraData): string {
  const arquivo = p.original_nome ?? p.documento_nome ?? '';
  if (p.campo !== null) {
    const campo = preencher(t.ondeCampo, { campo: nomesDosCampos[p.campo] });
    if (p.pagina_no_original === null || !arquivo) return campo;
    return `${campo} — ${preencher(t.ondePagina, { arquivo, pagina: p.pagina_no_original })}`;
  }
  if (p.pagina_no_original === null) return preencher(t.ondeArquivo, { arquivo });
  return preencher(t.ondePagina, { arquivo, pagina: p.pagina_no_original });
}

/**
 * O que faltou na pendência. E221.F2: o campo essencial sem lugar, com a conferência sem nenhuma
 * página ou documento em aberto, não diz "página ou documento que não foi lido" (todas foram
 * lidas): diz que a leitura não achou a informação e o que a equipe faz (GT-2026-0060 e outros
 * cinco da POC, 31/10 a 04/11).
 */
export function textoDaPendencia(p: PendenciaDaLeituraData, paginasEmAberto: boolean): string {
  const semLugar = p.original_id === null && p.documento_id === null;
  if (p.tipo === 'campo_essencial_sem_leitura' && semLugar && !paginasEmAberto) {
    return t.pendenciaSemLugar;
  }
  return t.pendencia[p.tipo];
}

export function ondeEstaOAchado(a: AchadoDoDocumentoData): string {
  if (a.pagina === null) return preencher(t.ondeArquivo, { arquivo: a.documento_nome });
  return preencher(t.ondePagina, { arquivo: a.documento_nome, pagina: a.pagina });
}
